import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Simple leave-day status for managers opening Activity from a DM.
 * Intentionally does not show leave reason.
 */
const SharedUserLeaveStatusModal = ({
  userName,
  leaveLabel = 'Full day leave',
  dateLabel,
  dayLabel,
  onClose,
  onOpenTimeline,
}) => ReactDOM.createPortal(
  <div className="fixed inset-0 z-[1000] flex items-center justify-center p-3 sm:p-5 bg-black/55 backdrop-blur-[2px]">
    <div
      className="relative w-full max-w-md overflow-hidden rounded-2xl shadow-2xl border border-indigo-200/70 dark:border-indigo-800 bg-white dark:bg-gray-800"
      role="dialog"
      aria-labelledby="shared-leave-status-title"
    >
      <div className="relative px-5 sm:px-6 pt-5 pb-4 bg-gradient-to-br from-indigo-600 via-violet-600 to-purple-700 text-white">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 p-1.5 rounded-lg hover:bg-white/20 transition-colors z-10"
          aria-label="Close"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <p className="text-indigo-100/90 text-xs sm:text-sm font-medium">
          Today’s status
          {dayLabel ? ` · ${dayLabel}` : ''}
          {dateLabel ? ` · ${dateLabel}` : ''}
        </p>
        <h2 id="shared-leave-status-title" className="text-2xl font-bold tracking-tight mt-1 pr-8">
          {userName}
        </h2>
      </div>

      <div className="px-5 sm:px-6 py-6">
        <div className="rounded-xl border border-indigo-200 dark:border-indigo-800 bg-indigo-50/80 dark:bg-indigo-950/40 px-4 py-5 text-center">
          <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-indigo-600 text-white mb-3">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </span>
          <p className="text-lg font-bold text-indigo-900 dark:text-indigo-100">
            {leaveLabel}
          </p>
          <p className="text-xs text-indigo-700/80 dark:text-indigo-300/80 mt-1.5">
            No work session today
          </p>
        </div>
      </div>

      <div className="px-5 sm:px-6 pb-5 flex gap-2.5">
        {typeof onOpenTimeline === 'function' && (
          <button
            type="button"
            onClick={onOpenTimeline}
            className="flex-1 rounded-xl text-slate-800 dark:text-slate-100 text-sm font-bold py-3 transition-colors shadow-sm bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700"
          >
            Day timeline
          </button>
        )}
        <button
          type="button"
          onClick={onClose}
          className={`${onOpenTimeline ? 'flex-1' : 'w-full'} rounded-xl text-indigo-800 dark:text-indigo-100 text-sm font-bold py-3 transition-colors shadow-sm bg-indigo-100 hover:bg-indigo-200 dark:bg-indigo-900/50 dark:hover:bg-indigo-900/70`}
        >
          Close
        </button>
      </div>
    </div>
  </div>,
  document.body,
);

export default SharedUserLeaveStatusModal;
